import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "../analytics";
import { logAppEvent } from "../Helpers/EventLogging";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view in both GA and Clarity
    logPageView(location.pathname);

    // Keep existing custom event logging
    logAppEvent("activity", {
      type: "page_view_event",
      page_path: location.pathname,
    });
  }, [location]);
};

export default usePageTracking;
